(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edd-cart"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.edd-cart__form').forEach(function (form) {
    form.querySelectorAll('[data-qty]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty-input]');
      var down = stepper.querySelector('[data-qty-down]');
      var up = stepper.querySelector('[data-qty-up]');
      if (!input) return;

      function commit(next) {
        if (next < 0) next = 0;
        input.value = next;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }

      if (down) {
        down.addEventListener('click', function () {
          commit(parseInt(input.value, 10) - 1 || 0);
        });
      }
      if (up) {
        up.addEventListener('click', function () {
          commit((parseInt(input.value, 10) || 0) + 1);
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-edd-col-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.href;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-community-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.edd-community').forEach(function (root) {
      var track = root.querySelector('[data-edd-gallery-track]');
      if (!track) return;
      var prev = root.querySelector('[data-edd-gallery-prev]');
      var next = root.querySelector('[data-edd-gallery-next]');
      var step = 236;
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step, behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-cookie-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var banner = document.getElementById('edd-cookie-banner');
    if (!banner) return;
    if (!localStorage.getItem('edd-cookie-dismissed')) {
      banner.hidden = false;
    }
    banner.querySelectorAll('[data-edd-cookie-dismiss]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        localStorage.setItem('edd-cookie-dismissed', '1');
        banner.hidden = true;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-edd-header]');
    if (!header) return;
    var toggle = header.querySelector('[data-edd-menu-toggle]');
    var drawer = document.querySelector('[data-edd-drawer]');
    if (!toggle || !drawer) return;
    var closers = drawer.querySelectorAll('[data-edd-menu-close]');

    function open() {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      window.setTimeout(function () { drawer.hidden = true; }, 320);
    }
    toggle.addEventListener('click', function () {
      if (drawer.hidden) { open(); } else { close(); }
    });
    closers.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) { close(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-main-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-edd-mp]').forEach(function (root) {
    /* ---- Gallery ---- */
    var gallery = root.querySelector('[data-edd-gallery]');
    if (gallery) {
      var slides = Array.from(gallery.querySelectorAll('.edd-mp__slide'));
      var thumbs = Array.from(gallery.querySelectorAll('.edd-mp__thumb'));
      function showSlide(i) {
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          showSlide(parseInt(t.getAttribute('data-index'), 10) || 0);
        });
      });
    }

    /* ---- Quantity ---- */
    var qty = root.querySelector('[data-edd-qty]');
    if (qty) {
      var qtyInput = qty.querySelector('.edd-mp__qty-input');
      var minus = qty.querySelector('[data-edd-qty-minus]');
      var plus = qty.querySelector('[data-edd-qty-plus]');
      function clamp() {
        var v = parseInt(qtyInput.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        qtyInput.value = v;
      }
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
      qtyInput.addEventListener('change', clamp);
    }

    /* ---- Variant selection ---- */
    var dataEl = root.querySelector('[data-edd-variants]');
    var idInput = root.querySelector('[data-edd-id]');
    if (!dataEl || !idInput) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionGroups = Array.from(root.querySelectorAll('[data-edd-option]'));
    var priceEl = root.querySelector('[data-edd-price]');
    var compareEl = root.querySelector('[data-edd-compare]');
    var saleEl = root.querySelector('[data-edd-sale]');
    var atc = root.querySelector('[data-edd-atc]');
    var atcLabel = atc ? atc.querySelector('span') : null;

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var input = group.querySelector('[data-edd-option-input]:checked') ||
                    group.querySelector('select[data-edd-option-input]');
        return input ? input.value : null;
      });
    }

    function matchVariant() {
      var chosen = selectedOptions();
      if (!chosen.length) return variants[0];
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      }) || null;
    }

    function update() {
      var v = matchVariant();
      if (!v) {
        if (atc) {
          atc.disabled = true;
          if (atcLabel) atcLabel.textContent = 'Unavailable';
        }
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price;
      if (compareEl) {
        if (v.compareRaw > v.priceRaw) {
          compareEl.innerHTML = v.compare;
          compareEl.hidden = false;
          if (saleEl) saleEl.hidden = false;
        } else {
          compareEl.hidden = true;
          if (saleEl) saleEl.hidden = true;
        }
      }
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
      }
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('[data-edd-option-input]').forEach(function (input) {
        input.addEventListener('change', update);
      });
    });

    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-offer-select"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.edd-offer').forEach(function (root) {
    var tiers = root.querySelectorAll('.edd-offer__tier');
    var variantInput = root.querySelector('[data-offer-variant]');
    var priceEl = root.querySelector('[data-offer-price]');
    var compareEl = root.querySelector('[data-offer-compare]');
    var perdayEl = root.querySelector('[data-offer-perday]');
    function select(label) {
      tiers.forEach(function (t) { t.classList.remove('is-selected'); });
      label.classList.add('is-selected');
      var radio = label.querySelector('[data-offer-tier]');
      if (radio && variantInput && radio.value) {
        variantInput.value = radio.value;
      }
      if (priceEl && label.dataset.price) { priceEl.textContent = label.dataset.price; }
      if (compareEl) { compareEl.textContent = label.dataset.compare || ''; }
      if (perdayEl) { perdayEl.textContent = label.dataset.perday || ''; }
    }
    tiers.forEach(function (label) {
      var radio = label.querySelector('[data-offer-tier]');
      if (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) select(label);
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.edd-carousel').forEach(function (section) {
    var track = section.querySelector('[data-edd-carousel-track]');
    var prev = section.querySelector('[data-edd-carousel-prev]');
    var next = section.querySelector('[data-edd-carousel-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.edd-carousel__card');
      var width = card ? card.offsetWidth : 240;
      return width + 16;
    }
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    var tabs = section.querySelectorAll('.edd-carousel__tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-product-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-edd-gallery]').forEach(function (gallery) {
    var slides = Array.from(gallery.querySelectorAll('.edd-hero__slide'));
    var thumbsWrap = gallery.querySelector('[data-edd-thumbs]');
    if (!slides.length || !thumbsWrap) return;
    var active = 0;

    slides.forEach(function (slide, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'edd-hero__thumb' + (i === 0 ? ' is-active' : '');
      var img = document.createElement('img');
      img.src = slide.src;
      img.alt = '';
      img.loading = 'lazy';
      btn.appendChild(img);
      btn.addEventListener('click', function () {
        setActive(i);
      });
      thumbsWrap.appendChild(btn);
    });

    var thumbs = Array.from(thumbsWrap.children);

    function setActive(i) {
      active = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        s.classList.toggle('is-active', j === active);
      });
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-active', j === active);
      });
    }

    var prev = gallery.querySelector('[data-edd-prev]');
    var next = gallery.querySelector('[data-edd-next]');
    if (prev) prev.addEventListener('click', function () { setActive(active - 1); });
    if (next) next.addEventListener('click', function () { setActive(active + 1); });
  });

  document.querySelectorAll('.edd-hero').forEach(function (hero) {
    var tiers = hero.querySelectorAll('.edd-hero__tier');
    if (!tiers.length) return;
    var variantInput = hero.querySelector('[data-hero-variant]');
    var qtyInput = hero.querySelector('[data-hero-qty]');
    var priceEl = hero.querySelector('[data-hero-price]');
    var compareEl = hero.querySelector('[data-hero-compare]');
    var perdayEl = hero.querySelector('[data-hero-perday]');
    function select(label) {
      tiers.forEach(function (t) { t.classList.remove('is-selected'); });
      label.classList.add('is-selected');
      var radio = label.querySelector('[data-hero-tier]');
      if (radio && variantInput && radio.value) { variantInput.value = radio.value; }
      // A 3-pack adds 3 real units of the same variant, so the cart line shows
      // "x3" and stock is decremented three times.
      if (qtyInput) { qtyInput.value = label.dataset.qty || '1'; }
      if (priceEl && label.dataset.price) { priceEl.textContent = label.dataset.price; }
      if (compareEl) { compareEl.textContent = label.dataset.compare || ''; }
      if (perdayEl) { perdayEl.textContent = label.dataset.perday || ''; }
    }
    tiers.forEach(function (label) {
      var radio = label.querySelector('[data-hero-tier]');
      if (radio) {
        radio.addEventListener('change', function () { if (radio.checked) select(label); });
      }
    });

    // The default tier is only marked as selected in the markup, so without this
    // the form would still submit the product's first variant while the page
    // shows a different pack selected.
    var checked = hero.querySelector('[data-hero-tier]:checked');
    if (checked) { select(checked.closest('.edd-hero__tier')); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-product-redefined"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.edd-redefined').forEach(function (root) {
    var modal = root.querySelector('[data-edd-label-modal]');
    var openBtn = root.querySelector('[data-edd-label-open]');
    var closeBtn = root.querySelector('[data-edd-label-close]');
    if (!modal || !openBtn) { return; }
    openBtn.addEventListener('click', function () {
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { modal.close(); });
    }
    modal.addEventListener('click', function (e) {
      if (e.target === modal) { modal.close(); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-transform"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.edd-transform').forEach(function (root) {
    var modal = root.querySelector('[data-edd-tf-modal]');
    var openBtn = root.querySelector('[data-edd-tf-open]');
    var closeBtn = root.querySelector('[data-edd-tf-close]');
    if (!modal || !openBtn) { return; }
    openBtn.addEventListener('click', function () {
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { modal.close(); });
    }
    modal.addEventListener('click', function (e) {
      if (e.target === modal) { modal.close(); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-video-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.edd-vr').forEach(function (root) {
    var track = root.querySelector('[data-edd-vr-track]');
    if (!track) return;
    var prev = root.querySelector('[data-edd-vr-prev]');
    var next = root.querySelector('[data-edd-vr-next]');

    function step() {
      var card = track.querySelector('.edd-vr__card');
      var width = card ? card.offsetWidth : 260;
      return width + 16;
    }
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    root.querySelectorAll('[data-edd-vr-card]').forEach(function (card) {
      var btn = card.querySelector('[data-edd-vr-play]');
      var wrap = card.querySelector('[data-edd-vr-video]');
      var video = wrap ? wrap.querySelector('video') : null;
      var frame = card.querySelector('.edd-vr__frame');
      var featured = card.hasAttribute('data-edd-vr-featured');

      function activate() {
        if (!wrap || card.classList.contains('is-playing')) return;
        wrap.hidden = false;
        card.classList.add('is-playing');
        if (video) {
          if (featured) {
            video.loop = false;
            video.muted = false;
            video.controls = true;
            try { video.currentTime = 0; } catch (e) {}
          }
          var playing = video.play();
          if (playing && typeof playing.catch === 'function') {
            playing.catch(function () {});
          }
        }
      }

      if (btn) { btn.addEventListener('click', activate); }
      if (featured && frame) {
        frame.addEventListener('click', function (e) {
          if (e.target === video && card.classList.contains('is-playing')) return;
          activate();
        });
      }
    });

    var featuredCard = track.querySelector('.edd-vr__card--featured');
    if (featuredCard) {
      requestAnimationFrame(function () {
        var tr = track.getBoundingClientRect();
        var fr = featuredCard.getBoundingClientRect();
        var delta = (fr.left - tr.left) - (track.clientWidth - fr.width) / 2;
        if (delta > 0) { track.scrollLeft = delta; }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-vsl"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-edd-vsl]').forEach(function (root) {
    var frame = root.querySelector('[data-edd-vsl-frame]');
    var video = root.querySelector('[data-edd-vsl-video]');
    var play = root.querySelector('[data-edd-vsl-play]');
    if (!frame || !video) return;

    function activate() {
      if (frame.classList.contains('is-playing')) return;
      frame.classList.add('is-playing');
      video.loop = false;
      video.muted = false;
      video.controls = true;
      try { video.currentTime = 0; } catch (e) {}
      var p = video.play();
      if (p && p.catch) { p.catch(function () {}); }
    }

    if (play) { play.addEventListener('click', activate); }
    frame.addEventListener('click', function (e) {
      if (e.target === video && frame.classList.contains('is-playing')) return;
      activate();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
